/**
 * Bandeau permanent affiché en haut de page lorsque le SuperAdmin est en mode
 * "Voir comme cet utilisateur". Toutes les actions d'écriture sont désactivées.
 */
import { Eye, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSuperAdminPreview } from "@/contexts/SuperAdminPreviewContext";
import { useEndUserPreview } from "@/hooks/useStartUserPreview";

const ROLE_LABELS: Record<string, string> = {
  admin: "SuperAdmin",
  admin_centrale: "Admin Centrale",
  admin_magasin: "Admin Magasin",
  admin_fournisseur: "Admin Fournisseur",
  chef_rayon: "Chef de rayon",
  chef_secteur_magasin: "Chef de secteur",
  collaborateur_magasin: "Collaborateur magasin",
  fournisseur: "Commercial fournisseur",
  supplier_guest: "Fournisseur invité",
  kam: "KAM",
};

export function SuperAdminPreviewBanner() {
  const { preview, isPreviewing } = useSuperAdminPreview();
  const endPreview = useEndUserPreview();

  if (!isPreviewing || !preview) return null;

  const roleLabel = preview.targetRole ? (ROLE_LABELS[preview.targetRole] ?? preview.targetRole) : "Aucun rôle";

  return (
    <div
      role="alert"
      className="sticky top-0 z-[100] w-full bg-destructive text-destructive-foreground border-b border-destructive/40 shadow-md"
    >
      <div className="container mx-auto flex items-center justify-between gap-3 px-4 py-2 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <Eye className="h-4 w-4 flex-shrink-0" />
          <span className="font-medium truncate">
            Mode visualisation SuperAdmin — Vous voyez Lyko comme{" "}
            <span className="font-semibold">{preview.targetLabel}</span>{" "}
            <span className="opacity-80">({roleLabel})</span>. Les actions sensibles sont désactivées.
          </span>
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => endPreview()}
          className="flex-shrink-0 gap-1"
        >
          <X className="h-3.5 w-3.5" />
          Quitter le mode visualisation
        </Button>
      </div>
    </div>
  );
}
